<template>
  <div class="navbar">
    <div class="navbar_top">
      <div class="inner_navs">
        <div class="left" >
          <img :src="siteMess.logo" alt="" />

          <!-- <p>{{ company.companyAppName || "" }}</p> -->
        </div>
        <div class="right">
          <div class="login" @click="handleLogin" v-if="!$store.getters.userId">
            <span>登录</span>
          </div>
          <el-popover v-else placement="bottom" width="50" trigger="click">
            <el-tooltip slot="reference" :disabled="$store.getters.name.length >= 6 ? false : true"
              :content="$store.getters.name" placement="bottom">
              <div class="login_success">
                <el-image style="width: 30px; height: 30px; border-radius: 50%; overflow: hidden"
                  :src="$store.getters.avatar || avatardefauter" fit="scale-down"></el-image>
                <div class="user_name">{{ $store.getters.name }}</div>
              </div>
            </el-tooltip>
            <ul class="logoutclick">
              <li @click="handlePropleCenter">个人中心</li>
              <li @click="setuppath">设置</li>
              <li @click="handleLogout">退出</li>
            </ul>
          </el-popover>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="nav_meus">
      <div class="nav_box">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          text-color="#333333" background-color="rgba(256,256,256,1)" active-text-color="#333333" menu-trigger="hover"
          :unique-opened="true">
          <template v-for="item in navListall">
            <el-submenu :index="item.id" v-if="item.submenuchildren" :key="item.id">
              <template slot="title">{{ item.name }}</template>
              <template v-for="itemb in item.submenuchildren">
                <el-submenu :index="itemb.id" v-if="itemb.tabchildren.length > 0" :key="itemb.id"
                  @click.native="moreTabops(itemb)">
                  <template slot="title">
                    <span>
                      {{ itemb.name }}
                    </span>
                  </template>
                  <el-menu-item v-for="itemc in itemb.tabchildren" :key="itemc.id" :index="itemc.id">{{ itemc.name
                  }}</el-menu-item>
                </el-submenu>
                <el-menu-item v-else :index="itemb.id" :key="itemb.paths">
                  {{ itemb.name }}
                </el-menu-item>
              </template>
            </el-submenu>
            <el-submenu v-else-if="item.tabchildren && item.tabchildren.length > 0" :index="item.id" :key="item.paths">
              <template slot="title">{{ item.name }}</template>
              <el-menu-item v-for="itemb in item.tabchildren" :key="itemb.id" :index="itemb.id">{{ itemb.name
              }}</el-menu-item>
            </el-submenu>
            <el-menu-item v-else-if="item.tabchildren && item.tabchildren.length == 0" :index="item.id" :key="item.paths"
              @click.native="moreTabops(item)">
              {{ item.name }}
            </el-menu-item>
            <el-menu-item :index="item.id" :key="item.name" v-else>
              {{ item.name }}
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getWebsiteConfigInfo,
} from "@/api/home";
import Sticky from "@/components/Sticky";
import bus from "@/utils/bus";
import { navList } from "@/api/navbar.js";
export default {
  name: "NavBar",
  components: {
    Sticky,
  },
  props: {
    company: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      search: "",
      avatardefauter: require("@/assets/images/avatardefauter.png"),
      logo: require("@/assets/images/logo3.png"),
      userName: "",
      navlistop: [], //不超过tab栏总宽的数据
      navListall: [], //所有的tab数据
      navlistoptwo: [], //超出tab栏的数据
      navitem: [
        { name: "首页", paths: "/home", id: "1010", oldvalpc: 1 },
        { name: "课程微课资源库", paths: "/course-center", id: "1030", oldvalpc: 2 },
        // { name: "行业动态", paths: "/notice", id: "1020", oldvalpc: 3 },
        { name: "高级职业技能培训库", paths: "/library", id: "1040", oldvalpc: 4 },
        {
          name: "考核习题库",
          paths: "/mockExamination",
          id: "1090",
          oldvalpc: 5,
        },
        // {
        //   name: "虚拟仿真实训",
        //   paths: "/moreops",
        //   id: "1050",
        //   oldvalpc: 100,
        //   // submenuchildren: [],
        // },
      ],
      siteMess:{},
      btnindex: this.$store.state.user.tabindex,
      childshow: false,
      mouId: null, //移入时的ID
      heightnav1: null,
      heightnavall: null,
      heigpxall: 0, //数据计算后的tab栏总宽度
      navboxwd: 0, //css的tab宽度
      xialahg: 0, //下拉高度
      childatall: [], //下拉菜单鼠标移入时子集的子集数据
      tabxlhg: 0, //tab栏下的子菜单高度
      tabchildren: [], //tab栏下的子菜单数据
      mousedata: [], //移入的数据
      clientWidth: 0, //浏览器宽度
      moremouid: null,
      activeIndex: this.$store.state.user.tabindex + "",
    };
  },
  created() {
    this.getnavlist();
    this.getWebsiteConfigInfo()
  },
  mounted() { },
  watch: {
    "$store.state.user.tabindex": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (newValue) {
          this.activeIndex = newValue + "";
        } else {
          this.activeIndex = newValue;
        }
      },
    },
  },
  methods: {
    //获取网站基础信息
    getWebsiteConfigInfo(){
      getWebsiteConfigInfo().then(res => {
        console.log(res.data)
        this.siteMess=res.data
      });
    },
    handleLogin() {
      var that = this;
      this.$login({
        loginSuccess() {
          that.$router.push({
            path: "/redirect" + that.$route.fullPath,
          });
        },
      });
    },
    handleLogout() {
      this.$store.dispatch("user/logout").then(() => {
        this.$message.success("退出成功");
        console.log(this.$route.fullPath);
        if (this.$route.fullPath !== "/home") {
          this.$router.push({ path: "/" });
        }
      });
    },
    handleSearch() {
      if (this.$route.path !== "/search-result") {
        this.$router.push({
          name: "SearchResult",
          params: { id: this.search },
        });
      } else {
        bus.$emit("setSearch", this.search);
      }
    },
    // 点击导航栏
    navpaths(item, index) {
      this.btnindex = index;
      this.$store.commit("user/SET_TABINDEX", index);
      this.$router.push({ path: item.paths });
    },
    navpathtwo(item) {
      this.mouseovertab(item);
      this.childshow = false;
      //typeShow == 2 ---学业评价
      if (item.typeShow == 2) {
        return;
      }

      this.$store.commit("user/SET_TABINDEX", item.id);
      this.$router.push({ path: "/navtab?navId=" + item.id });
    },
    navpathrees(item) {
      this.mouseover(item);
      //typeShow == 2 ---学业评价
      if (item.typeShow == 2) {
        return;
      }
      if (item.children.length > 0) {
      } else {
        this.childshow = false;
      }
      this.$store.commit("user/SET_TABINDEX", "0" + item.id);
      this.$router.push({ path: "/navtab?navId=" + item.id });
    },
    // 导航栏列表
    getnavlist() {
      let params = {
        type: 0,
        status: 0,
      };
      navList(params).then((res) => {
        console.log(JSON.parse(JSON.stringify(res)))
        if (res.code == 200) {
          var dataArr = [];
          let datachild = [];
          res.tabMenuList.forEach((value, index) => {
            value["tabshow"] = false;
            value["oldvalpc"] = 99;
            value["tabchildren"] = [];
            value.id = value.id + "";
            switch (Number(value.id)) {
              case 54:
                //学业评价
                value["oldvalpc"] = 100;
                value["paths"] = "/aa";
                value.children.forEach((val, index) => {
                  val.id = val.id + "";
                  switch (Number(val.typeShow)) {
                    case 2:
                      //学业报告
                      val["paths"] =
                        "/stureport?navId=" +
                        value.id +
                        "&childtype=" +
                        val.id +
                        "&typeShow=" +
                        val.typeShow;
                      break;
                    case 3:
                      //职业测评
                      val["paths"] =
                        "/evaluating?navId=" +
                        value.id +
                        "&childtype=" +
                        val.id +
                        "&typeShow=" +
                        val.typeShow;
                      break;
                    case 4:
                      //预警帮扶
                      val["paths"] =
                        "/earlyWarning?navId=" +
                        value.id +
                        "&childtype=" +
                        val.id +
                        "&typeShow=" +
                        val.typeShow;
                      break;
                    default:
                      break;
                  }
                });
                dataArr.push(value);
                break;
              default:
                break;
            }
            if (value.oldvalpc == 99 || value.id == 5) {
              datachild.push(value);
            }
            //将children---type==0的子tab栏筛选出来
            value.tabchildren = value.children.filter((el) => {
              return el.type === "0";
            });
          });
          datachild.forEach((val, index) => {
            val.id = val.id + "";
            for (let index = 0; index < val.children.length; index++) {
              if (val.children.length > 0) {
                val.children[index].id = val.children[index].id + "";
              }
            }
            val["paths"] = "/navtab?navId=" + val.id;
          });

          // for (let index = 0; index < this.navitem.length; index++) {
          //   let tabval = this.navitem[index];
          //   if (tabval.id == 1050) {
          //     // tabval.submenuchildren = datachild;
          //   }
          // }

          this.navListall = [...this.navitem, ...dataArr, ...datachild];
          this.navListall.sort((a, b) => a.oldvalpc - b.oldvalpc);
          this.navlistop = JSON.parse(JSON.stringify(res.tabMenuList));
          this.navlistoptwo = JSON.parse(JSON.stringify(res.tabMenuList));
          this.$store.commit("user/SET_NAVBARLIST", this.navlistop);
          console.log(dataArr)
          console.log(this.navListall, "navListall");
        }
      });
    },
    //移出
    mouseout() {
      this.moremouid = null;
      this.childatall = [];
      this.childshow = false;
    },
    //移入事件
    mouseover(childata) {
      this.moremouid = childata.id;
      this.mousedata = childata;
      this.childatall = childata.children.filter((el) => {
        return el.type === "0";
      });

      //重置点击状态
      this.tabshowlistall(childata);
      childata.tabshow = !childata.tabshow;
      if (childata.tabshow == false) {
        this.mouseout();
      }
    },
    //子集点击
    itchildbtns(itchild, item) {
      if (itchild.typeShow == 0 || itchild.typeShow == 1) {
        this.$store.commit("user/SET_TABINDEX", item.id);
        this.$store.commit("user/SET_ZIID", itchild.id);
        this.$router.push({
          path: "/navtab?navId=" + item.id + "&childtype=" + itchild.id,
        });
      }

      switch (Number(itchild.typeShow)) {
        case 2:
          //学业报告
          if (this.$store.getters && this.$store.getters.userId) {
            this.$store.commit("user/SET_TABINDEX", item.id);
            this.$store.commit("user/SET_ZIID", itchild.id);
            this.$router.push({
              path: "/stureport?navId=" + item.id + "&childtype=" + itchild.id,
            });
          } else {
            this.$message({
              message: "请先登录",
              type: "warning",
            });
          }
          break;
        case 3:
          //职业测评
          if (this.$store.getters && this.$store.getters.userId) {
            this.$store.commit("user/SET_TABINDEX", item.id);
            this.$store.commit("user/SET_ZIID", itchild.id);
            this.$router.push({
              path: "/evaluating?navId=" + item.id + "&childtype=" + itchild.id,
            });
          } else {
            this.$message({
              message: "请先登录",
              type: "warning",
            });
          }
          break;
        case 4:
          //预警帮扶
          if (this.$store.getters && this.$store.getters.userId) {
            this.$store.commit("user/SET_TABINDEX", item.id);
            this.$store.commit("user/SET_ZIID", itchild.id);
            this.$router.push({
              path: "/earlyWarning?navId=" + item.id + "&childtype=" + itchild.id,
            });
          } else {
            this.$message({
              message: "请先登录",
              type: "warning",
            });
          }
          break;
        default:
          break;
      }
      //隐藏下拉框
      item.tabshow = !item.tabshow;
      this.mouseoutTab();
    },
    // 更多菜单
    itchildbtnsTree(itchild, item) {
      if (itchild.typeShow == 0 || itchild.typeShow == 1) {
        this.$store.commit("user/SET_TABINDEX", item.id);
        this.$store.commit("user/SET_ZIID", itchild.id);
        this.$router.push({
          path: "/navtab?navId=" + item.id + "&childtype=" + itchild.id,
        });
      }

      switch (Number(itchild.typeShow)) {
        case 2:
          //学业报告
          if (this.$store.getters && this.$store.getters.userId) {
            this.$store.commit("user/SET_TABINDEX", "0" + item.id);
            this.$store.commit("user/SET_ZIID", "0" + itchild.id);
            this.$router.push({
              path: "/stureport?navId=" + item.id + "&childtype=" + itchild.id,
            });
          } else {
            this.$message({
              message: "请先登录",
              type: "warning",
            });
          }
          break;
        case 3:
          //职业测评
          if (this.$store.getters && this.$store.getters.userId) {
            this.$store.commit("user/SET_TABINDEX", "0" + item.id);
            this.$store.commit("user/SET_ZIID", "0" + itchild.id);
            this.$router.push({
              path: "/evaluating?navId=" + item.id + "&childtype=" + itchild.id,
            });
          } else {
            this.$message({
              message: "请先登录",
              type: "warning",
            });
          }
          break;
        case 4:
          //预警帮扶
          if (this.$store.getters && this.$store.getters.userId) {
            this.$store.commit("user/SET_TABINDEX", "0" + item.id);
            this.$store.commit("user/SET_ZIID", "0" + itchild.id);
            this.$router.push({
              path: "/earlyWarning?navId=" + item.id + "&childtype=" + itchild.id,
            });
          } else {
            this.$message({
              message: "请先登录",
              type: "warning",
            });
          }
          break;
        default:
          break;
      }
      //隐藏下拉框
      item.tabshow = !item.tabshow;
      this.mouseout();
    },
    morebtn() {
      this.childshow = !this.childshow;
      if (this.xialahg == 0 && this.childshow == true) {
        this.$nextTick(() => {
          //更多---下拉菜单的高度
          this.xialahg = this.$refs.xialahg.offsetHeight * -1 + -1 + "px";
        });
      }
      this.tabshowlistall({ id: "a1" });
      this.mouseoutTab();
    },
    //tab栏下的移入事件
    mouseovertab(item) {
      this.tabchildren = item.children.filter((el) => {
        return el.type === "0";
      });
      this.tabxlhg = this.tabchildren.length * 35 * -1 + -20 + "px";
      this.mouId = item.id;
      //重置点击状态
      this.tabshowlistall(item);
      item.tabshow = !item.tabshow;
      if (item.tabshow == false) {
        this.mouseoutTab();
      }
    },
    //重置点击状态
    tabshowlistall(item) {
      for (let index = 0; index < this.navlistop.length; index++) {
        if (this.navlistop[index].id == item.id) {
        } else {
          this.navlistop[index].tabshow = false;
        }
      }
    },
    //移出
    mouseoutTab() {
      this.tabchildren = [];
      this.mouId = null;
    },
    handlePropleCenter() {
      this.$router.push({ path: "/personal-center" });
    },
    // 设置
    setuppath() {
      this.$router.push({ path: "/mysetup" });
    },
    // ------
    handleSelect(key, keyPath) {
      let FathnavItem = this.navListall.filter((val) => {
        return val.id == keyPath[0];
      });
      switch (keyPath.length) {
        case 1:
          if (keyPath[0] == 1090) {
            // 判断考核习题库模块的登录
            if (this.$store.getters && this.$store.getters.userId) {
              this.$router.push({ path: FathnavItem[0].paths });
            } else {
              this.$message({
                message: "请先登录",
                type: "warning",
              });
            }
          } else {
            this.$router.push({ path: FathnavItem[0].paths });
          }
          break;
        case 2:
          let childnavItem;
          //更多菜单
          if (keyPath[0] == 1050) {
            childnavItem = FathnavItem[0].submenuchildren.filter((val) => {
              return val.id == keyPath[1];
            });
            this.navpathtwo(childnavItem[0]);
          } else {
            childnavItem = FathnavItem[0].children.filter((val) => {
              return val.id == keyPath[1];
            });
            this.itchildbtns(childnavItem[0], FathnavItem[0]);
          }
          break;
        case 3:
          childnavItem = FathnavItem[0].submenuchildren.filter((val) => {
            return val.id == keyPath[1];
          });
          let childnavItem2 = childnavItem[0].tabchildren.filter((val) => {
            return val.id == keyPath[2];
          });
          this.itchildbtns(childnavItem2[0], childnavItem[0]);
          break;
        default:
          break;
      }
    },
    moreTabops(itemb) {
      this.navpathtwo(itemb);
    },
  },
};
</script>
<style lang="scss" scoped>
.navbar {
  background: #fff;
  margin-bottom: 15px;

  .navbar_top {
    width: 100%;

    // background: url("../../assets/images/navbg.png");
    .inner_navs {
      width: 1200px;
      height: 90px;
      margin: 0 auto;
      align-items: center;

      .left {
        float: left;

        img {
          height: 44px;
          margin-top: 28px;
        }
      }

      .right {
        float: right;
        display: flex;
        align-items: center;
        margin: 35px 0 0 15px;

        i {
          color: #333333;
          font-size: 24px;
          margin-right: 10px;
        }

        .login {
          width: 90px;
          height: 36px;
          background: linear-gradient(90deg, #0D5923 0%, #0B9232 100%);
          border-radius: 18px;
          color: #ffffff;
          line-height: 36px;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s;
          text-align: center;
        }

        .login_success {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          position: relative;
          cursor: pointer;

          .user_name {
            font-size: 20px;
            font-weight: bold;
            max-width: 132px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-left: 10px;
          }
        }
      }
    }
  }

  //导航栏
  .nav_meus {
    width: 100%;
    height: 32px;
    // background: linear-gradient(90deg, #045923 0%, #1d4434 100%);

    .nav_box {
      width: 1200px;
      display: flex;
      align-items: center;
      font-size: 16px;
      position: relative;
      user-select: none;
      margin: 0 auto;
    }
  }
}
</style>
<style lang="scss">
/* 改变elementui 侧边栏移入颜色 */
.nav_box {
  .el-menu-item:hover {
    font-weight: bold;
    background: none !important;
    color: #1D4434 !important;
  }

  .el-submenu__title:hover {
    font-weight: bold;
    background: none !important;
    color: #1D4434 !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: #1D4434 !important;
  }

  .el-menu-item.is-active {
    background: #1D4434 !important;
    color: #fff !important;
    font-weight: bold;
    border-bottom: none !important;

    span {
      color: #1D4434 !important;
    }
  }

  .el-submenu__title i {
    color: #1D4434 !important;
  }

  .el-menu {
    font-size: 16px !important;
    background: none !important;
  }

  .el-submenu__title,
  .el-menu-item {
    font-size: 16px !important;
    height: 32px !important;
    line-height: 32px !important;
    margin-right: 20px !important;
  }

  .el-menu-item {
    border-radius: 32px;
  }
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background: #1D4434 !important;
  color: #fff !important;

}

.el-menu {
  background: #1D4434 !important;

}

.el-menu-item:hover {
  font-weight: bold;
  background: none !important;
  color: #ffffff !important;
}

.el-submenu__title:hover {
  font-weight: bold;
  background: none !important;
  color: #ffffff !important;
}

// 登录样式
.logoutclick {
  font-size: 14px;
}

.logoutclick li {
  padding: 10px;
  cursor: pointer;
}

.logoutclick li:last-of-type {
  border-top: 1px solid #d2d2d2;
}

.logoutclick li:hover {
  color: #1d4434;
}

.logoutclick img {
  margin-right: 5px;
}
</style>
